import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5841 2.37596C11.836 2.20801 12.1642 2.20801 12.4161 2.37596L21.4161 8.37596C21.7607 8.60573 21.8539 9.07138 21.6241 9.41603C21.3944 9.76067 20.9287 9.8538 20.5841 9.62404L12.0001 3.90139L3.4161 9.62404C3.07146 9.8538 2.60581 9.76067 2.37604 9.41603C2.14628 9.07138 2.23941 8.60573 2.58405 8.37596L11.5841 2.37596ZM11.2501 6.75C11.2501 6.33579 11.5859 6 12.0001 6H12.0081C12.4223 6 12.7581 6.33579 12.7581 6.75V6.758C12.7581 7.17221 12.4223 7.508 12.0081 7.508H12.0001C11.5859 7.508 11.2501 7.17221 11.2501 6.758V6.75ZM12.0001 9C14.5502 8.99897 17.0966 9.19658 19.6161 9.59103C19.9811 9.64817 20.2501 9.96257 20.2501 10.332V20.25H21.0001C21.4143 20.25 21.7501 20.5858 21.7501 21C21.7501 21.4142 21.4143 21.75 21.0001 21.75H3.00008C2.58587 21.75 2.25008 21.4142 2.25008 21C2.25008 20.5858 2.58587 20.25 3.00008 20.25H3.75008V10.332C3.75008 9.9625 4.0192 9.64806 4.38426 9.591C6.866 9.2031 9.40993 9.00002 12.0001 9ZM5.25008 20.25H7.50008V12.75C7.50008 12.3358 7.83587 12 8.25008 12C8.66429 12 9.00008 12.3358 9.00008 12.75V20.25H11.2501V12.75C11.2501 12.3358 11.5859 12 12.0001 12C12.4143 12 12.7501 12.3358 12.7501 12.75V20.25H15.0001V12.75C15.0001 12.3358 15.3359 12 15.7501 12C16.1643 12 16.5001 12.3358 16.5001 12.75V20.25H18.7501V10.9781C16.5146 10.6589 14.259 10.4991 12.0004 10.5C9.70884 10.5 7.45482 10.6639 5.25008 10.9782V20.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
